'use strict';
angular.module("controllers").controller('appCtrl', function ($scope) {});
